module.exports = __webpack_public_path__ + "media/images/lp_uesugi_interview-1c2799ef96afd0ef51fd1972deac699f.webp";